import { HostListener, ChangeDetectorRef, Component, OnDestroy } from '@angular/core'
import { Title, Meta } from '@angular/platform-browser'
import { NavigationService } from 'src/app/service/navigation.service';
import { QuoteComponentService } from './quote-component.service';
import { takeWhile } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { QuoteService } from 'src/app/service/quote.service';
function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // Expiration in days
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
@Component({
  selector: 'app-quote',
  templateUrl: 'quote.component.html',
  styleUrls: ['quote.component.css'],
})
export class QuoteComponent implements OnDestroy {

  screenWidth: number;
  private isActiveRoute: boolean;
  constructor(private title: Title, private meta: Meta, private navigate: NavigationService, private cdr: ChangeDetectorRef, public quoteService: QuoteComponentService, private navigator: Router, private router: ActivatedRoute, private quoteServiceAPI: QuoteService) {
    this.title.setTitle('Quote - Blue Assist')
    this.meta.addTags([
      {
        property: 'og:title',
        content: 'Quote - Blue Assist',
      },
    ]);
    this.getScreenSize();
    this.isActiveRoute = true;
    this.router.params.pipe(
      takeWhile(i => this.isActiveRoute)
    ).subscribe(params => {
      const stepToGo = params['step'];
      const id = params['id'];
      if (stepToGo && !id) {
        this.quoteService.setCurrentStepValue(1)
        this.navigator.navigate(['/']);
        return
      }
      if ((stepToGo === 'pay' || stepToGo === 'plan' || stepToGo === 'activation') && id) {
        const setpsNumber = {
          'pay': 7,
          'plan': 4,
          'activation': 8
        }
        const self = this
        this.quoteService.setCurrentStepValue(0);
        this.quoteServiceAPI.getQuote$(id).subscribe(res => {
          const resultJson = JSON.stringify(res);
          const result = JSON.parse(resultJson);
          self.quoteServiceAPI.quoteModel = result
          if (result.rateResponse) {
            let resultData200 = result.rateResponse;
            const defaultValue = {
              dependentsRate: 0,
              ownerRate: 0,
              rate: 0,
              membersCount: 0,
              appliesForOwner: false,
              value: false
            }
            resultData200.maxCoverage = {
              dependentsRate: resultData200.coverage.dependentsRate || 0,
              ownerRate: resultData200.coverage.ownerRate || 0,
              rate: resultData200.price || 0,
              membersCount: 0,
              appliesForOwner: false,
              value: true
            }

            resultData200.number = result.number;
            resultData200.cancellationDueToCatastrophicTrip = defaultValue;
            resultData200.sportPractice = defaultValue;
            resultData200.preexistingMedicalConditions = defaultValue;
            resultData200.futureMom = defaultValue;
            resultData200.pets = defaultValue;
            resultData200.legalVipAssistance = defaultValue;
            resultData200.riderRates && resultData200.riderRates.map((riderRate: any) => {
              const data = {
                dependentsRate: riderRate.rateInfo.dependentsRate || 0,
                ownerRate: riderRate.rateInfo.ownerRate || 0,
                applicableDependentsCount: riderRate.rateInfo.dependentsCount || 0,
                rate: riderRate.rateInfo.rate || 0,
                membersCount: riderRate.rateInfo.membersCount || 0,
                appliesForOwner: riderRate.rateInfo.ownerIncluded || false,
                value: true
              }
              switch (riderRate.riderId) {
                case 2:
                  resultData200.cancellationDueToCatastrophicTrip = data;
                  break;
                case 3:
                  resultData200.sportPractice = data;
                  break;
                case 4:
                  resultData200.preexistingMedicalConditions = data;
                  break;
                // case 1:
                //     resultData200.cancellationDueToCatastrophicTrip = data;
                //     break;

                case 6:
                  resultData200.futureMom = data;
                  break;

                case 5:
                  resultData200.pets = data;
                  break;
                case 7:
                  resultData200.legalVipAssistance = data;
                  break;
              }
            })

            self.quoteServiceAPI.quoteRateModel = { ...resultData200 };
          }


          setTimeout(() => {
            this.quoteService.setIdValue(id)
            this.quoteService.setCurrentStepValue(setpsNumber[stepToGo]) //stepToGo
          }, 1000);
        })

      } else {
        this.quoteService.setCurrentStepValue(1)
      }
    });
  }

  ngOnInit(): void {
    document.cookie = ".AspNetCore.Identity.Application=CfDJ8CTLpubzZI5KjBM7PR9npgAq-ZxLbdebHpZTq7vk8LZcxwdmTgprXNZCilo2a1AG93pPY1PVx5Gp73XRFm6zKWnrQwoSEfjQCBLihzw_nEnxMhlaepiqPM-ECGXsNkApuGlsSysREPNne_bqv3YeYtNXBC2x2Ql3AsyXx_dvgafWKmCcuOMdY1ddSI3xqjSUsRpY3qcRpxRHrzcNn-wcPVgxpojWATaYZi6BV-ZdIJ6mcdKwsIE4o4jSO3dJDU2jTwUn-NUT2MaxHVHQfKCHncBRkN4whVof4bqWApBeybcNVNmkPDdJniP2dFXBSNGYwHbCNxIjJSFQf7QDejKfIyhQQtf1vnZdKr7IbY3u3y6NQXTRfCmqxRneHZ9WN7omfr_2-GiFYFGMAUHd8OKes5c9M4oOTa8lWVJOtgW7XJ4EWh4zdXOnE3i4Rc8Nt2rEXxjqTgWxffe9vWi9duXPmJia7c4xivHAWfkUlwK52UPLvWeNbG6QyC3oa-wssccx0vJounesdfUANnpFmiHUDukyz_h5Jes2Cw4k0im1NlOFC4zFj6atUE93x7luHIo3jDd5Ei1Xv7JuRo5Cv-Y2o6mBlN0o-h9qS0z_OBHnVC3jcL2TE0n-ADmKlT8nbJVH7Jk3TD0i1sQAbYR7FTv36qwp1pPAFNQswB3mjkXr2yiabbMCzH8jOH1V5zYA3ROx0nDarHHbRC5Q8DzWtmOvbwREpGol0SmvFVoNo-sKhAn9K1R_BReMoZg4G4wSYS_vC2p7JvYzVcBetRDxwtN1WR40BrkuqJasecmvT1lBuzPVt_zIyK-5_EQ0cqBf-InpDHZD0YWtcbIrq-tZbxzid6gr3KimMovdBKsvN4CbHUIk; ARRAffinity=701402fd4c1d419de470fef5c052af6706cb11a8faa9d31bb90dc7a8773b697a; ARRAffinitySameSite=701402fd4c1d419de470fef5c052af6706cb11a8faa9d31bb90dc7a8773b697a"
    // setCookie(".AspNetCore.Identity.Application", "CfDJ8CTLpubzZI5KjBM7PR9npgCAGaSiDfY3FGMWiDhS_zKaEh5PhvX3Uexryigxr3IKlC-UoqQqEKvchfugVi0LNRJyPb-nYIWe3b3hP5pzdIC1T9_sau9wr22y8_HHNvFmpewScatUeSNHlbHToDwCsjTX7I7sc0K34jFJzPEMTqhIr_1tQ4AxCu6O04IMcX4pN2PqusWgkHI1QwEQNXVCi_HYUt_Q7bSDwFhNq_bXrYA2VvJJNeCJFSc3ZLaGWsEISbv2jqxXWgH3TmhBDdLL-prRdi8wNDy8YYnbGQXKDZLZBKX30tz0kZGWCfj9uWgW2v6ZMGRdxK44Pmqv8C9B2tuJ_A9AUc_a2_OX9O8M1HKl6FM9hFsTtjRgeS6T2Bfui053NJjI3KHvamchoPIB9KZWWPONZSpWyQPlE5-od2k_1RDvcKjJ6GrwPGQkTljOCn558zZ9VMd8jmkuxrFk0EKUcvew100fhLl2tvPSFq9BlOTCLI63d5xcLnOKYmEVaE501AHkEdb5q0wBLbBPiucx2nASXL5zufGn4bKwh6f9mBltO77s17ma0Dp1oA2nffMVXG-0DEDhuSFp9lRSx6iyt6UC6esNsNQqb10P-wX7moeTP_PIfFmSQn6aoGsqXufzcGFZFe1Ypi6KEx-ReESlBMUKzez13dpyHPdQ2pp4O_FnfZlh4cObp6faAnKBQaJ40ylpm6PWIMTnNvZ2MHu1Ayz7aX0ARNnZNPAb-hwBcjVOLzZYQz9fBIDB5pO-_foces6Wnz0wUfDWE_dvD-FqCthBZFk5kC2a82c3-q7it4mnIjJZSSBfpUNNXcnrHhVf8a9R9BYSbOiAkWNym1h03Qz5jy7_JmCM0-EBf4cz", 1);
    // setCookie("ARRAffinity", "701402fd4c1d419de470fef5c052af6706cb11a8faa9d31bb90dc7a8773b697a", 1)
    // setCookie("ARRAffinitySameSite", "701402fd4c1d419de470fef5c052af6706cb11a8faa9d31bb90dc7a8773b697a", 1)
  }
  ngOnDestroy(): void {
    this.isActiveRoute = false;
    // Reset quoteModel to empty default state when component unmounts
    this.quoteServiceAPI.resetQuoteModel();
  }

  /** Indicador de pasos (bolitas y etiquetas Cotizar / Customizar / Pagar, repetido en cada paso): un solo gestor delegado */
  @HostListener('click', ['$event'])
  onStepIndicatorClick(ev: MouseEvent): void {
    const target = ev.target as HTMLElement;
    if (!target || !target.closest || !target.matches('img, .letter-style-simulate-steps-blue, .letter-style-simulate-steps-grey')) { return; }
    const col = target.closest('.col') as HTMLElement | null;
    if (!col || col.classList.contains('d-flex')) { return; }
    const row = col.parentElement;
    const scope = row ? row.parentElement : null; // en planes es .form-step; en la pasarela, la columna que agrupa las dos filas
    if (!row || !scope) { return; }
    const txt = scope.textContent || '';
    if (!(txt.includes('Cotizar') && txt.includes('Customizar') && txt.includes('Pagar'))) { return; }
    const cols = Array.from(row.children).filter(c => c.classList.contains('col') && !c.classList.contains('d-flex'));
    const idx = cols.indexOf(col);
    const steps = [1, 4, 7];
    if (idx < 0 || idx >= steps.length) { return; }
    if (this.quoteService.goToStep(steps[idx])) {
      this.cleanupModalArtifacts();
      this.navigate.scrollTo("quoteTop");
    }
  }

  nextStep(step: number = 0): void {
    // Clean up modals before step transition
    this.cleanupModalArtifacts();
    this.quoteService.nextStep(step)
    this.navigate.scrollTo("quoteTop");
  }

  prevStep(step: number = 0): void {
    // Clean up modals before step transition
    this.cleanupModalArtifacts();
    this.quoteService.prevStep(step)
  }

  /**
   * Clean up any modal artifacts before step transitions
   */
  private cleanupModalArtifacts(): void {
    try {
      // Immediate cleanup (no setTimeout)
      // Remove all modal backdrops
      const backdrops = document.querySelectorAll('.modal-backdrop, .modal-backdrop.fade, .modal-backdrop.show');
      backdrops.forEach(backdrop => {
        backdrop.remove();
      });
      
      // Remove modal-open class from body
      document.body.classList.remove('modal-open');
      
      // Force reset body styles
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      
      // Hide any visible modals (DOM only)
      const visibleModals = document.querySelectorAll('.modal.show');
      visibleModals.forEach(modal => {
        modal.classList.remove('show');
        (modal as HTMLElement).style.display = 'none';
        modal.setAttribute('aria-hidden', 'true');
      });

      // Note: We don't dispose Bootstrap instances here to avoid conflicts with component lifecycle
    } catch (error) {
      console.error('Error cleaning up modal artifacts:', error);
    }
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    setTimeout(() => {
      this.screenWidth = screen.width;
      this.cdr.detectChanges(); // Detect changes manually
    });
  }
}
